.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-10) var(--space-6);
  text-align: center;
}

.sm {
  padding: var(--space-6) var(--space-4);
}

.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  margin-bottom: var(--space-2);
  color: var(--color-danger-fg);
}

.title {
  color: var(--color-heading);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.message {
  max-width: 32rem;
  color: var(--color-text-muted);
  font-size: var(--font-size-sm);
}

.reference {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  color: var(--color-text-subtle);
  font-size: var(--font-size-xs);
}

.code {
  padding: 0.0625rem var(--space-1);
  border-radius: var(--radius-xs);
  background-color: var(--color-surface-sunken);
  color: var(--color-text-muted);
  user-select: all;
  overflow-wrap: anywhere;
}

.copy {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: var(--radius-sm);
  color: var(--color-text-muted);
}

.copy:hover {
  background-color: var(--color-surface-hover);
  color: var(--color-text);
}

.actions {
  margin-top: var(--space-3);
}
